import React from "react";
import { useSearchParams } from "react-router-dom";
import ClaimableAuthenticatorV2 from "../../components/Shared/ClaimableAuthenticatorV2";

interface QueryAuthGateProps {
  children: React.ReactNode;
}

const QueryAuthGate: React.FC<QueryAuthGateProps> = ({ children }) => {
  const [searchParams] = useSearchParams();
  const newUser =
    searchParams.get("newUser")?.toLowerCase() === "true" || false;
  const email = searchParams.get("email");

  const defaultTab = newUser ? "signUp" : "signIn";

  return (
    <ClaimableAuthenticatorV2
      defaultTab={defaultTab}
      prefilledEmail={email || undefined}
    >
      {children}
    </ClaimableAuthenticatorV2>
  );
};

export default QueryAuthGate;
